import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export enum ButtonStyle {
	DEFAULT = 'default',
	OUTLINE = 'outline',
}

export interface Args {
	trackingOrigin: string;
	buttonStyle?: ButtonStyle;
}

export default class CommonDemoButtonComponent<T extends Args> extends Component<T> {
	@service('account') declare accountService: Service.Account;

	get extraClasses(): string {
		const mainClass = 'demo-button',
			modifierClass = `${mainClass}--${this.args.buttonStyle || ButtonStyle.DEFAULT}`;

		return [mainClass, modifierClass].join(' ');
	}

	@action
	openDemoAccount() {
		void this.accountService.redirectToDemoAccount(this.args.trackingOrigin);
	}
	<template>
		<a role="button" class={{this.extraClasses}} {{on "click" this.openDemoAccount}}>
			<CommonUiIconComponent @name="DataboxLogo" @size="lg" />
			<span>Try Databox demo account</span>
			<CommonUiIconComponent @name="External" @size="xs" />
		</a>
	</template>
}
